import { tokens } from "@opendoor/tokens-studio/dist/bricks-next/tokens/Components";
import { Box } from "../../Box/index.mjs";
import { Text } from "../../Text/index.mjs";
import { jsx } from "react/jsx-runtime";
const {
    textInput: textInputTokens
  } = tokens,
  InputError = ({
    errorText
  }) => errorText && typeof errorText == "string" ? /* @__PURE__ */jsx(Box, {
    testID: "text-input-error-message",
    children: /* @__PURE__ */jsx(Text, {
      tag: "span",
      typography: textInputTokens.typography.errorText.default,
      color: textInputTokens.color.content.errorMessage.default,
      children: errorText
    })
  }) : null;
export { InputError };